<template>
  <v-row>
    <v-col cols="12">
      <EstudiosTable :estudios="estudios" />
    </v-col>
    <v-col cols="12">
      <APrimaryButton
        label="Cerrar"
        @click="CLOSE_DIALOG()"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import APrimaryButton from '../atoms/APrimaryButton.vue';
import EstudiosTable from './EstudiosTable.vue';

export default {
  components: { APrimaryButton, EstudiosTable },

  computed: {
    ...mapState({
      estudios: (state) => state.preregistro.estudios,
    }),
  },

  methods: {
    ...mapMutations('dialog', ['CLOSE_DIALOG']),
  },
};
</script>
